import React, { useState } from 'react';
import Button from 'react-bootstrap/lib/Button';
import Modal from 'react-bootstrap/lib/Modal';
import { toFirstLetterUppercase } from '@silverfort-nodelibs/common/utils/common';
import { ES_LOGS_GROUP_BY_UI_OPTIONS } from '@silverfort-nodelibs/common/utils/consts';

import styles from './LogsExportModal.module.css';
import { bigNumberToText } from '../utils';
import { Dropdown } from '@silverfort/sf-components';

const LogsExportModal = ({ onExport, onCancel, authLogsAggsMaxDocsToSearch, currentLogsCount }) => {
    const [selectedGroupBy, setSelectedGroupBy] = useState();
    const isAboveThreshold = selectedGroupBy && currentLogsCount > authLogsAggsMaxDocsToSearch;

    const groupByOptions = ES_LOGS_GROUP_BY_UI_OPTIONS.map((option) => ({
        label: toFirstLetterUppercase(option.label),
        value: option.value
    }));

    const onGroupByChanged = (newValue) => {
        setSelectedGroupBy(newValue);
    };

    const onExportClick = () => {
        onExport(selectedGroupBy);
    };

    return (
        <Modal
            enforceFocus={false}
            id={styles.logsExportModal}
            show={true}
            className={'z-[5000]'}
            keyboard={true}
            backdropClassName="z-[900]"
            backdrop="static">
            <Modal.Header>
                <Modal.Title>Export Logs</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div className={`${styles.logsGroupByField}`}>
                    <div className={styles.groupByLabel}>Group By: </div>
                    <div className={styles.groupByFieldData}>
                        <div className={` ${styles.groupBySelector}`}>
                            <Dropdown
                                items={groupByOptions.map((option) => ({
                                    value: option.value,
                                    title: option.label
                                }))}
                                selectedItems={selectedGroupBy}
                                variant="trigger"
                                onChange={(value) => {
                                    onGroupByChanged(value);
                                }}
                            />
                        </div>
                    </div>
                </div>
                {isAboveThreshold && (
                    <div
                        className={
                            styles.validationErrorMsg
                        }>{`The number of log entries exceeds the limit (${bigNumberToText(
                        authLogsAggsMaxDocsToSearch
                    )} entries). Reduce the number and try again.`}</div>
                )}
            </Modal.Body>
            <Modal.Footer>
                <div className={styles.footerButtons}>
                    <Button onClick={onCancel}>Cancel</Button>
                    <Button bsStyle="success" disabled={isAboveThreshold} onClick={onExportClick}>
                        Export
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default LogsExportModal;
